import { CashFlowPlanDetail } from "../../../../backend/src/common/dashboard/cashFlowPlanDetail";
import UMBAL from "../../graphql/accountingLine/UpsertManualBudgetAccountingLine.gql"
export class CashFlowPlanDetailFront extends CashFlowPlanDetail {
    apollo
    constructor(apollo, companyId, budgetId, cashFlowPlanDetail) {
        super(companyId, budgetId, cashFlowPlanDetail)
        this.apollo = apollo
    }

    async upsertManualBudgetAccountingLine(accountingLine) {
        const result = await this.apollo.mutate({
            mutation: UMBAL,
            variables: {
                companyId: this.companyId,
                budgetId: this.budgetId,
                accountingLine
            }
        });
        if (!this.budgetId) {
            this.budgetId = result.data.upsertManualBudgetAccountingLine.budgetId
        }
        return result.data.upsertManualBudgetAccountingLine
    }
}
